import { FETCH_HOMEPAGE } from '../actions/types';

const INITIAL_STATE = [];

export const inspirationHomeReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case FETCH_HOMEPAGE:
			const { homepage } = action.payload;

			homepage.inspirationsHome.forEach((inspiration, key) => {
				state[key] = inspiration;
			});

			return state;

		default:
			return state;
	}
};
